



























import {
    State,
    Action,
    Getter,
    Mutation
} from "vuex-class";
import {
    Component,
    Vue,
    Prop,
    Watch
} from "vue-property-decorator";
import {
    pageDataType
} from "../types";
import {
    HOST
} from "../global";
import {
    ADD_ANIMATION
} from "../store/mutations.names";
import {
    TimelineMax,
    Power1,
    Power2,
    Power4,
    Power3
} from "gsap";
@Component({
    name: "ProjectHeader"
})
export default class ProjectHeader extends Vue {
    @Getter("pageData") public pageData!: pageDataType;
    public HOST: string = HOST;
    @Prop() public last!: boolean;
    @Getter("isPreloaderLoaded") public isPreloaderFinished!: boolean;
    @Getter("mainTimeLineIsFinished") public mtlFinished!: boolean;
    @Mutation(ADD_ANIMATION) public[ADD_ANIMATION]: any;
    public addedAnimation: boolean = false;
    public prheader(): void {
        var prheader = new TimelineMax({});
        prheader

            .set('.project-description', {
                visibility: 'visible'
            })
            .from(".img-overlay", 0.1, {
                autoAlpha: 0,
                opacity: 0,
                scale: .8,
                ease: Power4.easeOut,
                clearProps: "all"
            }, '-=1')

            .fromTo(
                ".project-description picture img",
                .6, {
                    scale: 1.12,
                    opacity: 0,
                    autoAlpha: 0,
                }, {
                    scale: 1,
                    y: 0,
                    opacity: 1,
                    autoAlpha: 1,
                    ease: Power1.easeOut,
                    clearProps: "all"
                }, '+=0.1'
            )

            .from(".sub-title", .8, {
                autoAlpha: 0,
                opacity: 0,
                y: 200,
                ease: Power2.easeOut,
                clearProps: "all"
            }, '-=0.2')
            .from(".m-title", .8, {
                autoAlpha: 0,
                opacity: 0,
                y: 200,
                ease: Power2.easeOut,
                clearProps: "all"
            }, '-=.65');

        if (this.last) {
            this.$emit("loaded");
        }
    }
}
